
  import arrayToSentence from 'array-to-sentence';

  export default {
    props: { bundle: { type: Object, required: true } },
    computed: {
      costDetail () {
        if (!this.bundle.discount_tiers.length) {
          return this.$t('cost.monthly', { amount: this.$n(this.bundle.nondiscounted_monthly_cost, 'currency') });
        }
        const tiers = this.bundle.discount_tiers.map((tier, index) => {
          const key = `cost.${index ? 'otherTier' : 'firstTier'}`;
          return this.$t(key, { amount: this.$n(tier.cost, 'currency'), duration: tier.duration });
        }).concat(this.$t('cost.thereafter', { amount: this.$n(this.bundle.nondiscounted_monthly_cost, 'currency') }));
        return arrayToSentence(tiers);
      },
      inclusions () {
        const items = [];
        if (this.bundle.first_year_discounts) {
          items.push(this.$t('cost.inclusions.discounts', [this.$currency(this.bundle.first_year_discounts)]));
        }
        if (this.setupCharge) {
          items.push(this.$t('cost.inclusions.setup', [this.$currency(this.setupCharge)]));
        }
        if (this.bundle.cashback) {
          items.push(this.$t('cost.inclusions.cashback', [this.$currency(this.bundle.cashback_amount)]));
        }
        return items.length ? ' ' + this.$t('cost.including', [arrayToSentence(items)]) : '';
      },
      setupCharge () {
        return this.bundle.cost_setup + this.bundle.cost_equipment;
      }
    }
  };
